export enum PaymentModalsFlow {
  PRECHECKOUT = 'precheckout',
  DEFAULT = 'default',
}
